import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorsInterceptor } from '../../../shared/src/app/interceptors/errors.interceptor';
import { TokenInterceptor } from '../../../shared/src/app/interceptors/token.interceptor';
import { initializeApp } from "firebase/app";
import { ServiceWorkerModule } from '@angular/service-worker';


import { environment } from '../../../../environments/environment';
import { VesselScheduleModule } from '../../../portal/src/app/vessel-schedule/vessel-schedule.module';
import { ConsentBannerComponent } from './consent/consent-banner.component';
import { provideNativeDateAdapter } from '@angular/material/core';



initializeApp(environment.firebase);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    VesselScheduleModule,
    ConsentBannerComponent

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true },
    provideAnimationsAsync(),
    // was provided by MaterialModule (MatNativeDateModule) before it was dropped from the app shell; datepickers need it
    provideNativeDateAdapter(),
    provideClientHydration(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
